var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoefTempSticlaWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b84c3a94-c8cb-4c8f-bcf4-934cf811342b",
    "data-name": "coef_temp_sticla",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199 197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ac5f1977-b56a-4a08-8675-1c208d95d5c0,.b0a6b524-86cf-4533-a531-ab60437645f9,.e3903c34-94ee-4a77-a7b1-ae42f9299641,.ecfef2d2-0395-4c8d-9ad9-65584890c380,.fc507085-b022-4d92-aa7e-9c56fb63b12c{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.ac5f1977-b56a-4a08-8675-1c208d95d5c0{stroke-width:8px;}.fe6c9d73-1ac3-4dfb-946a-c4499bc990fa{fill:#fff;}.e3903c34-94ee-4a77-a7b1-ae42f9299641{stroke-width:3px;}.fc507085-b022-4d92-aa7e-9c56fb63b12c{stroke-width:6px;}.b0a6b524-86cf-4533-a531-ab60437645f9{stroke-width:10px;}.ecfef2d2-0395-4c8d-9ad9-65584890c380{stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coef_temp_sticla_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bc763d2f-3889-49d8-ada3-41e8a7841813",
    "data-name": "termostat copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac5f1977-b56a-4a08-8675-1c208d95d5c0",
    d: "M36.41,158.06a19.5,19.5,0,1,1-23.85,0",
    transform: "translate(-1)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac5f1977-b56a-4a08-8675-1c208d95d5c0",
    x1: 12,
    y1: 157,
    x2: 12,
    y2: 114
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac5f1977-b56a-4a08-8675-1c208d95d5c0",
    x1: 35,
    y1: 157,
    x2: 35,
    y2: 114
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac5f1977-b56a-4a08-8675-1c208d95d5c0",
    d: "M13,114.17a11.5,11.5,0,0,1,23,0",
    transform: "translate(-1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fe6c9d73-1ac3-4dfb-946a-c4499bc990fa",
    cx: 24,
    cy: 173.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3903c34-94ee-4a77-a7b1-ae42f9299641",
    x1: 35.42,
    y1: 124.46,
    x2: 30.54,
    y2: 124.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3903c34-94ee-4a77-a7b1-ae42f9299641",
    x1: 35.5,
    y1: 130.5,
    x2: 30.5,
    y2: 130.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3903c34-94ee-4a77-a7b1-ae42f9299641",
    x1: 35.5,
    y1: 136.5,
    x2: 30.5,
    y2: 136.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "fc507085-b022-4d92-aa7e-9c56fb63b12c",
    x1: 24,
    y1: 173,
    x2: 24,
    y2: 130
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ad9d38dd-424d-4940-8699-2a7199c47a0c",
    "data-name": "fereastra"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "b0a6b524-86cf-4533-a531-ab60437645f9",
    points: "45.25 175 194 175 194 5 24 5 24 100"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ecfef2d2-0395-4c8d-9ad9-65584890c380",
    x1: 163,
    y1: 14,
    x2: 184.5,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "ecfef2d2-0395-4c8d-9ad9-65584890c380",
    x1: 137,
    y1: 15,
    x2: 183.5,
    y2: 61.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoefTempSticlaWhite);
export default __webpack_public_path__ + "static/media/coef_temp_sticla_white.512cab2a51f18385071e24d99a001594.svg";
export { ForwardRef as ReactComponent };